<template>
  <div v-cloak class="expertDetail">
    <!-- 头部banner图 -->
    <div class="swiper">
      <div class="toptexts">
        <div class="imgtitle">专家专栏</div>
        <div class="texts">新鲜资讯、随时播报、一网打尽</div>
      </div>
    </div>

    <!-- 中间内容 -->
    <div class="Bread">
      <Bread :list="breadList" />
    </div>

    <div id="w-1200px" class="r-container">
      <div class="con-left">
        <div
          class="pa-t-30 flex f-center search-box f-jcenter pa-b-50 b-b-1-e3"
        >
          <div class="flex f-center f-between search">
            <el-input
              border="none"
              placeholder="请输入关键字搜索"
              v-model="name"
            ></el-input>
            <div class="search-btn" @click="getList()">立即搜索</div>
          </div>
        </div>
        <div class="">
          <div
            class="boxs-r ma-t-30 height302 flex f-between pa-b-20 b-b-1-e3"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div v-if="item.Image" class="ma-r-20">
              <img
                :src="item.Image"
                class="img_263 c-p"
                @click="toDetail(item.Id)"
              />
            </div>

            <div
              class="flex flex-direction flex-grow-1 pa-t-10 pa-r-20 f-between"
            >
              <div>
                <div
                  class="t-omit-2 fon-16 bold c-p"
                  @click="toDetail(item.Id)"
                >
                  {{ item.Name }}
                </div>
                <div
                  class="ma-t-20 fon-15 c-8a t-omit-4 c-p t-justify"
                  @click="toDetail(item.Id)"
                >
                  {{ item.Summary }}
                </div>
              </div>
              <div class="c-8a flex f-between fon-14 ma-t-10">
                <div>{{ item.ReleaseTime }}</div>
                <div class="flex f-center p-r">
                  <div>
                    <i class="iconfont icon-yanjing"></i>
                    {{ item.ViewCount }}
                  </div>
                  <!-- <div>
                                        <i class="iconfont ma-l-20" :class="
                                            item.IsCollection ? 'icon-star2' : 'icon-xingxing'
                                        " @click="toCollection(item.Id, index)"></i>
                                    </div> -->
                  <div>
                    <!-- 隐藏分享 -->
                    <!-- <i class="iconfont icon-fenxiang11 ma-l-20" 
                                            @mouseenter="shareMouseenter(item.Id)"
                                            @mouseleave="shareMouseleave(item.Id)"
                                            ></i> -->
                  </div>
                 
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="dataList.length == 0" class="width100 pa-t-100">
          <Empty></Empty>
        </div>

        <div class="fy">
          <el-pagination
            @current-change="handleCurrentChange"
            :hide-on-single-page="true"
            :current-page.sync="pageIndex"
            :page-size="pageSize"
            layout="prev, pager, next, jumper"
            :total="totals"
          >
          </el-pagination>
        </div>
      </div>
      <div class="con-right-wrap">
        <div class="con-right">
          <div class="t-center">
            <div class="head-img-wrap">
              <img
                v-if="specialDetail.Image"
                :src="specialDetail.Image"
                alt=""
                srcset=""
                class="head-portrait"
              />
              <img
                src="../img/authentication.png"
                class="head-portrait-icon"
                alt=""
                srcset=""
              />
            </div>
            <div class="flex f-jcenter ma-t-10 ma-b-10">
              <div class="fon-24 c-000 bold c-p ma-l-40">
                {{ specialDetail.Name }}
              </div>
              <div class="fon-16 c-fff tips flex f-center f-jcenter ma-lr-30">
                {{ specialDetail.Type }}
              </div>
            </div>
            <!-- 标签 -->
            <div class="flex f-center f-wrap">
              <div
                class="ma-r-20 fon-16 tips2 flex f-center f-jcenter flex-grow-1"
                v-for="(tips, indx) in specialDetail.Labels"
                :key="indx"
              >
                {{ tips }}
              </div>
            </div>
            <!-- 标题 -->
            <div class="t-left ma-t-10">
              {{ specialDetail.Title }}
            </div>
            <div class="t-left ma-t-10">
              {{ specialDetail.Summary }}
            </div>
            <div class="flex f-between c-a8 ma-t-10">
              <div>
                <i class="iconfont icon-fabuxuqiu"></i>
                文章:{{ specialDetail.Count }}
              </div>
              <div>
                <i class="iconfont icon-yanjing"></i>
                人气：{{ specialDetail.Popularity }}
              </div>
            </div>
            <!-- 关注按钮 -->
            <div class="flex f-between ma-t-20 p-r">
              <div
                class="c-p"
                @click="postExpertFocusOn()"
                :class="specialDetail.Fans ? 'Fans' : 'btn-focus'"
              >
                {{ specialDetail.Fans ? "已关注" : "关注" }}
              </div>
              <div
                class="btn-share c-p"
                @mouseenter="shareMouseenter()"
                @mouseleave="shareMouseleave()"
              >
                分享
              </div>

              <!-- 分享框 -->
              <div
                class="box-share"
                id="box-share"
                @mouseenter="shareMouseenter()"
                @mouseleave="shareMouseleave()"
              >
                <div class="flex f-center">
                  <div class="t-center">
                    <img
                      v-if="qrUrl"
                      :src="qrUrl"
                      alt=""
                      srcset=""
                      width="120"
                      class="img-qrCode"
                    />
                    <div class="t-center">微信扫码分享</div>
                  </div>
                  <div class="p-r">
                    <img
                      src="../img/weibo.png"
                      alt=""
                      srcset=""
                      width="60"
                      class="c-p ma-l-10"
                      title="点击分享"
                      @click="weibo()"
                    />
                  </div>
                  <div class="p-r ma-l-20">
                    <img
                      src="../img/qzone.png"
                      alt=""
                      srcset=""
                      width="60"
                      class="c-p"
                      title="点击分享"
                      @click="QQShare()"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 推荐文章 -->
            <div class="pa-t-20">
              <div class="bold b-b-1-e3 pa-b-10 t-left">推荐文章</div>
              <div class="ma-t-20">
                <div
                  class="ma-b-20 fon-16 flex t-omit-1 t-left c-p"
                  v-for="(items, indx) in dataHotList"
                  :key="indx"
                  @click="toDetail(items.Id)"
                >
                  {{ items.Name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.head-img-wrap {
  position: relative;
  height: 222px;
  width: 222px;
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 0px rgba(6, 0, 1, 0.568);
  border: 3px solid #fff;
  .head-portrait {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    height: 100%;
  }
  .head-portrait-icon {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }
}

.pa-b-50 {
  padding-bottom: 50px;
}

.athor {
  width: 30px;
  height: 30px;
}

.img-qrcode {
  .frame-img {
    margin: 20px auto;
    border: 2px solid #e4e7ed;
    height: 200px;
    width: 200px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 99%;
    }
  }
}

.con-right-wrap {
  width: 30%;

  .btn-focus {
    width: 80px;
    padding: 10px 20px;
    background: #009944;
    border-radius: 10px;
    color: #fff;
  }
  .Fans {
    width: 80px;
    padding: 10px 20px;
    border: 1px solid #eee;
    border-radius: 10px;
  }

  .btn-share {
    width: 80px;
    padding: 10px 20px;
    background: #00a0e9;
    border-radius: 10px;
    color: #fff;
  }

  .tips {
    background: #eb6100;
    border-radius: 10px;
    width: 90px;
    height: 30px;
  }

  .tips2 {
    background: #bfbfbf;
    height: 30px;
    border-radius: 10px;
    margin-bottom: 10px;
    min-width: 100px;
    padding: 0 10px;
  }

  .right_box:not(:last-child) {
    border-bottom: 1px #eee solid !important;
  }

  .right_box {
    width: 100%;
    max-height: 287px;
    margin: 0 auto;
    margin-top: 20px;
    padding-bottom: 10px;

    & img {
      width: 100%;
      height: 199px;
      object-fit: cover;
    }

    .img_12 {
      height: 12px;
      width: 12px;
    }

    .img_14 {
      height: 14px;
      width: 14px;
    }
  }
}

.con-right {
  width: 100%;
  background: #fff;
  padding: 20px;
  height: auto;
}

.con-left {
  width: 65%;
  background: #fff;
  padding: 20px;
  overflow: hidden;

  .tips2 {
    background: #bfbfbf;
    height: 30px;
    padding: 0 10px;
    border-radius: 10px;
  }
}

.t-justify {
  text-align: justify;
}

.p-r {
  position: relative;
}

.expertDetail {
  .el-tabs__nav-wrap {
    width: 100%;
  }

  .box-share {
    position: absolute;
    top: -150px;
    width: 290px;
    right: 0;
    background: #fff;
    padding: 10px;
    box-shadow: 0 1px 4px 0 #bdbdbd;
    border-radius: 2px;
    display: none;
  }

  .h-auto {
    height: auto;
  }

  .chunk {
    display: inline-block;
    width: 5px;
    height: 23px;
    background: #234775;
    border-radius: 3px;
  }

  .li-news {
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-top: 20px;

    .chunk-top {
      width: 20px;
      height: 20px;
      border-radius: 3px;
      display: inline-block;
      text-align: center;
      color: #fff;
      line-height: 19px;
      margin-right: 6px;
    }

    .chunk-top1 {
      background: #ff0000;
    }

    .chunk-top2 {
      background: #ff2b2b;
    }

    .chunk-top3 {
      background: #ff5e5e;
    }

    .chunk-top-other {
      background: #7d7d7d;
    }
  }
}

.containerss {
  width: 1200px;

  margin: 0 auto;
  background: #ffffff;
  padding: 0px 14px 25px 14px;
  box-sizing: border-box;

  .fy {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .product-main {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;

    .product-list {
      width: 370px;
      height: 121px;
      margin-right: 20px;
      margin-bottom: 38px;
      display: flex;
      justify-content: flex-start;

      .p-image {
        width: 35%;
        height: 121px;
        margin-right: 9px;

        .p-imgs {
          width: 121px;
          height: 121px;
          border-radius: 10px;
        }
      }

      .p-title {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 8px;
      }

      .p-detail {
        // width:100%;
        font-size: 14px;
        height: 38px;
        line-height: 19px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .p-right {
        width: 65%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .download {
        width: 90px;
        height: 30px;
        background: rgba(15, 117, 189, 1);
        border-radius: 20px;
        font-size: 14px;
        font-family: MicrosoftYaHei;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        text-decoration: none;
      }
    }
  }
}

.expertDetail {
  min-width: 1200px;
  background: rgba(245, 247, 250, 1);
}

.expertDetail .swiper {
  width: 100%;
  height: 314px;
  background-image: url(../img/ExpertColumn.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .toptexts {
    width: 736px;
    position: absolute;
    top: 28%;
    margin: 0 auto;
    left: 50%;
    margin-left: -368px;
    font-size: 20px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;

    color: #fff;
    opacity: 0.75;
    text-align: center;

    .texts {
      line-height: 30px;
      letter-spacing: 3px;
      font-size: 16px;
    }

    .imgtitle {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}

.fy {
  margin-top: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.expertDetail .r-container {
  width: 1200px;
  // height: 600px;
  // min-height: 500px;
  box-sizing: border-box;
  // padding: 30px 40px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  min-height: 1150px;

  display: flex;
  justify-content: space-between;
}

.expertDetail .r-container {
  margin-bottom: 30px;

  .el-tabs__header {
    display: flex;
    justify-content: left;
    margin-top: 15px;
  }

  .el-tabs__content {
    // min-width: 1080px;
    margin: 0 auto;
  }

  .el-tabs__item {
    padding: 0 60px;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }

  .el-tabs__active-bar {
    height: 4px;
    font-weight: bold;
    background: #234775;
  }

  .is-active {
    font-size: 14px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #234775;
  }

  .el-tabs__content {
    // margin-top: 45px;
  }
}

.expertDetail .student {
  width: 1100px;
  height: 106px;
  margin-bottom: 32px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;

  .img-left {
    width: 20%;
    height: 106px;

    .img-lefts {
      width: 187px;
      height: 106px;
    }
  }

  .text-right {
    width: 80%;

    .title {
      font-size: 14px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #333333;
      margin-top: 3px;
      margin-bottom: 5px;
    }

    .text-detail {
      padding-right: 100px;
      box-sizing: border-box;
      font-size: 12px;
      line-height: 18px;
      font-family: MicrosoftYaHei;
      color: rgba(102, 102, 102, 1);
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      line-clamp: 3;
      -webkit-box-orient: vertical;
    }

    .icons {
      // width: 100%;
      margin-top: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .deletes {
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: rgba(102, 102, 102, 1);
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          i {
            font-size: 18px;
          }
        }
      }

      .icons-left {
        width: 100%;
        padding-right: 100px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .icons-left-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }

      .delete-right {
        width: 40%;

        .icons-right-children {
          display: flex;
          justify-content: flex-start;
          align-items: center;

          div {
            font-size: 12px;
            font-family: MicrosoftYaHei;
            color: rgba(102, 102, 102, 1);
            margin-left: 8px;
          }
        }
      }
    }
  }
}

.boxs-r {
  background: #ffffff;

  // box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.2);
  // border-radius: 10px;
  .img_263 {
    width: 230px;
    height: 149px;
    object-fit: cover;
  }

  .img_30 {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    position: absolute;
    top: 205px;
    left: 10px;
  }
}

.ma-t-60 {
  margin-top: 60px !important;
}

.ma-t-10 {
  margin-top: 10px !important;
}

.ma-t-12 {
  margin-top: 12px !important;
}

.height40 {
  height: 36px;
}

.c-234775 {
  color: #234775;
}

.search-box {
  position: relative;

  .search {
    position: absolute;
    background: #eeeeee;
    border-radius: 33px;
    width: 280px;

    .el-input {
      border-radius: 33px;

      .el-input__inner {
        border-radius: 33px;
        background: #eeeeee;
        border: none !important;
      }
    }

    .search-btn {
      background: #00479d;
      border-radius: 0px 33px 33px 0px;
      height: 40px;
      line-height: 40px;
      padding: 0 15px;
      width: 100px;
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
<script>
var _this;
import { getExpertNews, getspecialDetail, postExpertFocusOn } from "../api.js";
import Bread from "../components/Bread.vue";
//二维码生成
import QRCode from "qrcode";
// studycollect
export default {
  name: "expertDetail",
  components: {
    Bread,
  },
  data() {
    return {
      id: 0,
      activeName: "",
      pageIndex: 1,
      pageSize: 16,
      name: "",
      totals: 0, //一个分类下的总条数
      dataList: [],
      kinds: [],
      breadList: [
        { name: "专家专栏", path: "Expert" },
        { name: "专家详情", path: "/expertDetail" },
      ],
      sortType: 0,
      hotNewsList: [],
      qrUrl: "",
      detail: {},
      specialDetail: {},
      dataHotList: [],
    };
  },

  created() {
    this.id = this.$route.query.id;
    this.getList();
    this.loadDataHotList();
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0);
    next();
  },

  // 其他页面进来时更新初始数据
  activated() {},

  methods: {
    //关注或取消
    postExpertFocusOn() {
      let token = localStorage.getItem("AccessToken") || "";
      if (!token) {
        this.$confirm("您还未登录请先登录?", "提示", {
          confirmButtonText: "去登录",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$router.push("/Login");
          })
          .catch(() => {
            return false;
          });
      } else {
        postExpertFocusOn({
          id: this.id,
        }).then(() => {
          this.$message.success("操作成功");
          this.specialDetail.Fans = !this.specialDetail.Fans;
        });
      }
    },
    //根据关键字搜索
    loadDataSearch(name) {
      _this.name = name;
      _this.getList();
    },
    //获取列表
    getList() {
      let data = {
        title: this.name,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        expertsId: this.id,
      };
      getExpertNews(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataList = res.data.Data.List;

          this.totals = res.data.Data.TotalCount;
        }
      });
      //获取专家详情
      getspecialDetail({ id: this.id }).then((res) => {
        this.specialDetail = res.data.Data;

        this.loadDataQrUrl()
      });
    },
    //获取热门推荐文章列表
    loadDataHotList() {
      let data = {
        pageIndex: 1,
        pageSize: 10,
        expertsId: this.id,
      };
      getExpertNews(data).then((res) => {
        if (res.data.Code == 0) {
          this.dataHotList = res.data.Data.List;
        }
      });
      //获取专家详情
      getspecialDetail({ id: this.id }).then((res) => {
        this.specialDetail = res.data.Data;
      });
    },

    toDetail(id = 1) {
      this.$router.push({
        path: "/specialDetail",
        query: { id: id },
      });
    },
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.pageIndex = e;
      this.getList();
    },
    //微博分享
    weibo() {
      var query = {
        title: this.specialDetail.Name,
        url: "http://www.fz-ai.net/specialDetail?id=" + this.specialDetail.Id,
      };
      if (this.specialDetail.Image) {
        query.pic = this.specialDetail.Image;
      }
      let url =
        "http://service.weibo.com/share/share.php?" + this.buildUrlQuery(query);
      window.open(url);
    },
    //QQ空间分享
    QQShare() {
      var query = {
        title: this.specialDetail.Name,
        summary: this.specialDetail.summary,
        url: "http://www.fz-ai.net/specialDetail?id=" + this.specialDetail.Id,
      };
      if (this.specialDetail.Image) {
        query.pics = this.specialDetail.Image;
      }
      let url =
        "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" +
        this.buildUrlQuery(query);
      window.open(url);
    },
    //拼接url
    buildUrlQuery(query) {
      var queryItems = [];
      for (var k in query) {
        queryItems.push(k + "=" + encodeURIComponent(query[k] || ""));
      }
      return queryItems.join("&");
    },
    //获取二维码图片url
    loadDataQrUrl() {
      var _this = this;
      QRCode.toDataURL(
        "http://www.fz-ai.net/expertDetail?id=" + this.specialDetail.Id,
        {},
        function (err, url) {
          if (err) throw err;
          _this.qrUrl = url;
        }
      );
    },
    //鼠标悬浮分享按钮
    shareMouseenter() {
      let dom = document.getElementById("box-share");
      dom.style.display = "block";
    },
    //鼠标移开分享按钮
    shareMouseleave() {
      let dom = document.getElementById("box-share");
      dom.style.display = "none";
    },
  },
};
</script>
